module.exports = __webpack_public_path__ + "static/img/4bc7c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/sendPoints/logo.png
// module id = 685
// module chunks = 2